// Assets/membership-toggle-desktop.js

document.addEventListener('DOMContentLoaded', function() {
  var monthlyBtn = document.getElementById('monthly-btn');
  var annuallyBtn = document.getElementById('annually-btn');
  var monthlyMemberships = document.getElementById('monthly-memberships');
  var annuallyMemberships = document.getElementById('annually-memberships');

  if (monthlyBtn && annuallyBtn && monthlyMemberships && annuallyMemberships) {
    // Ensure the initial state is set correctly
    monthlyMemberships.style.display = 'flex';
    annuallyMemberships.style.display = 'none';

    monthlyBtn.addEventListener('click', function() {
      monthlyMemberships.style.display = 'flex';
      annuallyMemberships.style.display = 'none';

      monthlyBtn.classList.add('active');
      annuallyBtn.classList.remove('active');

      // Accessibility
      monthlyBtn.setAttribute('aria-pressed', 'true');
      annuallyBtn.setAttribute('aria-pressed', 'false');
    });

    annuallyBtn.addEventListener('click', function() {
      monthlyMemberships.style.display = 'none';
      annuallyMemberships.style.display = 'flex';

      annuallyBtn.classList.add('active');
      monthlyBtn.classList.remove('active');

      // Accessibility
      annuallyBtn.setAttribute('aria-pressed', 'true');
      monthlyBtn.setAttribute('aria-pressed', 'false');
    });
  }
});
